// src/components/About.js
import React, { useEffect, useContext, useState } from 'react';
import { AppContext } from '../../context/AppContext';
import axios from 'axios';
import ProfileSidebar from './ProfileSidebar';

const Profile = () => {

  const { loggedIN, user, isAuthenticated } = useContext(AppContext);

  const [profileData, setProfileData] = useState({
    name: user?.data?.name || '',
    email: user?.data?.email || '',
  });

  // Fetch Bearer token (Assuming it's stored in localStorage)
  const token = localStorage.getItem('authToken');

  // Handle input changes dynamically
  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === 'image' && files.length > 0) {
      // Handle the image upload separately
      const file = files[0]; // Get the first selected file
      setProfileData((prevData) => ({
        ...prevData,
        [name]: file, // Store the file object in the state
      }));
    } else {
      // Handle regular text inputs
      setProfileData((prevData) => ({
        ...prevData,
        [name]: value, // Update other fields with regular text values
      }));
    }
  };



  const saveChanges = async () => {
    try {
      const formData = new FormData();

      // Append the profile data to the FormData
      Object.keys(profileData).forEach((key) => {
        formData.append(key, profileData[key]);
      });

      // Example API call to save the profile data including the image
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/editProfile`, // Replace with your API URL
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`, // Attach Bearer token
            'Content-Type': 'multipart/form-data', // Set correct content type for file upload
          },
        }
      );


      if (response.status) {
        // alert('Profile Updated Successfully');

        loggedIN(token, response.data)
      }
    } catch (error) {
      console.error('Error updating profile:', error);
      alert('Failed to update profile. Please try again.');
    }
  };

  return (
    <div className="container mt-5">
      <div className="row">
        {/* Sidebar */}
        <ProfileSidebar />

        {/* Profile Details */}
        <div className="col-md-8">
          <div className="card p-4 mb-4">
            <h5 className="mb-4">Edit Profile</h5>
            <div className="d-flex">
              <div className="profile-img me-3">
                <img
                  src="https://via.placeholder.com/100"
                  alt="Profile"
                  className="rounded-circle"
                />

                <input name='image' type='file' onChange={handleChange} className="form-control" />
              </div>
              <div>
                <div className="mb-3">
                  <label className="form-label">Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name='name'
                    value={profileData.name}
                    onChange={handleChange}
                    placeholder='Your Name'
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Email</label>
                  <input
                    type="email"
                    className="form-control"
                    name='email'
                    value={profileData.email}
                    onChange={handleChange}
                    placeholder='Your Email Address'
                  />
                </div>
                <button className="btn btn-primary" onClick={saveChanges}>Save Changes</button>
              </div>
            </div>
          </div>

          {/* Change Phone Section */}
          <div className="card p-4 mb-4">
            <h5>Change Phone Number</h5>
            <div className="d-flex">
              <input
                type="text"
                className="form-control me-3"
                placeholder="Phone"
              />
              <button className="btn btn-secondary" disabled>
                Send OTP
              </button>
            </div>
          </div>

          {/* Change Password Section */}
          <div className="card p-4">
            <h5>Change Password</h5>
            <p>Get OTP on your registered phone</p>
            <button className="btn btn-primary">Send OTP</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
